<template>
  <div class="py-4 container-fluid dashboard-container">
    <!-- Header Section -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="dashboard-header p-4 border-radius-xl">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h2 class="text-white mb-1 font-weight-bold">
                <i class="ni ni-shop me-2"></i>
                Painel de Controle
              </h2>
              <p class="text-white-50 mb-0">
                Acompanhe seus pedidos em tempo real
              </p>
            </div>
            <div class="d-flex align-items-center">
              <span class="badge bg-white text-dark px-3 py-2">
                <i class="ni ni-calendar-grid-61 me-1"></i>
                {{ currentDate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Statistics Cards -->
    <div class="row">
      <!-- Pedidos Ativos -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card stat-card stat-card-ativos h-100">
          <div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p
                  class="text-sm mb-1 text-uppercase font-weight-bold opacity-8"
                >
                  Pedidos Ativos
                </p>
                <h2 class="font-weight-bolder mb-0 stat-number">
                  {{ dashboardStats.ativos }}
                </h2>
                <p class="mb-0 mt-2 opacity-8">
                  <span class="badge badge-sm bg-dark bg-opacity-25 me-1">
                    <i class="ni ni-time-alarm"></i>
                  </span>
                  Aguardando retirada
                </p>
              </div>
              <div class="icon-container bg-gray-900 bg-opacity-20">
                <i class="ni ni-basket text-3xl"></i>
              </div>
            </div>
            <div class="progress mt-3" style="height: 6px">
              <div
                class="progress-bar bg-white"
                role="progressbar"
                :style="{ width: percentAtivos + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pedidos Retirados -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card stat-card stat-card-retirados h-100">
          <div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p
                  class="text-sm mb-1 text-uppercase font-weight-bold opacity-8"
                >
                  Pedidos Retirados
                </p>
                <h2 class="font-weight-bolder mb-0 stat-number">
                  {{ dashboardStats.retirados }}
                </h2>
                <p class="mb-0 mt-2 opacity-8">
                  <span class="badge badge-sm bg-dark bg-opacity-25 me-1">
                    <i class="ni ni-check-bold"></i>
                  </span>
                  Finalizados com sucesso
                </p>
              </div>
              <div class="icon-container bg-gray-900 bg-opacity-20">
                <i class="ni ni-delivery-fast text-3xl"></i>
              </div>
            </div>
            <div class="progress mt-3" style="height: 6px">
              <div
                class="progress-bar bg-white"
                role="progressbar"
                :style="{ width: percentRetirados + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pedidos Cancelados -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card stat-card stat-card-cancelados h-100">
          <div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p
                  class="text-sm mb-1 text-uppercase font-weight-bold opacity-8"
                >
                  Cancelados
                </p>
                <h2 class="font-weight-bolder mb-0 stat-number">
                  {{ dashboardStats.cancelados }}
                </h2>
                <p class="mb-0 mt-2 opacity-8">
                  <span class="badge badge-sm bg-dark bg-opacity-25 me-1">
                    <i class="ni ni-fat-remove"></i>
                  </span>
                  Pedidos cancelados
                </p>
              </div>
              <div class="icon-container bg-gray-900 bg-opacity-20">
                <i class="ni ni-fat-remove text-3xl"></i>
              </div>
            </div>
            <div class="progress mt-3" style="height: 6px">
              <div
                class="progress-bar bg-white"
                role="progressbar"
                :style="{ width: percentCancelados + '%' }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Total Pedidos -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card stat-card stat-card-total h-100">
          <div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p
                  class="text-sm mb-1 text-uppercase font-weight-bold opacity-8"
                >
                  Total de Pedidos
                </p>
                <h2 class="font-weight-bolder mb-0 stat-number">
                  {{ dashboardStats.total }}
                </h2>
                <p class="mb-0 mt-2 opacity-8">
                  <span class="badge badge-sm bg-dark bg-opacity-25 me-1">
                    <i class="ni ni-archive-2"></i>
                  </span>
                  Todos os pedidos
                </p>
              </div>
              <div class="icon-container bg-gray-900 bg-opacity-20">
                <i class="ni ni-chart-bar-32 text-3xl"></i>
              </div>
            </div>
            <div class="progress mt-3" style="height: 6px">
              <div
                class="progress-bar bg-white"
                role="progressbar"
                style="width: 100%"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Row -->
    <div class="row mt-2">
      <!-- Doughnut Chart -->
      <div class="col-lg-5 mb-4">
        <div class="card chart-card h-100">
          <div class="card-header pb-0 pt-4 bg-transparent">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="mb-0 text-dark">
                  <i class="ni ni-chart-pie-35 me-2 text-primary"></i>
                  Distribuição de Pedidos
                </h6>
                <p class="text-sm text-muted mb-0">Visão geral por status</p>
              </div>
              <button
                class="btn btn-sm btn-outline-dark"
                @click="refreshData"
                title="Atualizar dados"
              >
                <i class="fas fa-sync-alt"></i>
              </button>
            </div>
          </div>
          <div class="card-body d-flex flex-column justify-content-center">
            <div
              class="chart-container"
              style="height: 200px; width: 100%; position: relative"
            >
              <canvas
                ref="doughnutCanvas"
                style="display: block; width: 100%; height: 100%"
              ></canvas>
            </div>
            <div class="row mt-4">
              <div class="col-4 text-center">
                <span class="legend-dot bg-success"></span>
                <p class="text-xs text-muted mb-0">Ativos</p>
                <h6 class="mb-0">{{ dashboardStats.ativos }}</h6>
              </div>
              <div class="col-4 text-center">
                <span class="legend-dot bg-warning"></span>
                <p class="text-xs text-muted mb-0">Retirados</p>
                <h6 class="mb-0">{{ dashboardStats.retirados }}</h6>
              </div>
              <div class="col-4 text-center">
                <span class="legend-dot bg-danger"></span>
                <p class="text-xs text-muted mb-0">Cancelados</p>
                <h6 class="mb-0">{{ dashboardStats.cancelados }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bar Chart -->
      <div class="col-lg-7 mb-4">
        <div class="card chart-card h-100">
          <div class="card-header pb-0 pt-4 bg-transparent">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="mb-0 text-dark">
                  <i class="ni ni-sound-wave me-2 text-info"></i>
                  Comparativo de Status
                </h6>
                <p class="text-sm text-muted mb-0">
                  Análise visual dos pedidos
                </p>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div
              class="chart-container-bar"
              style="height: 250px; width: 100%; position: relative"
            >
              <canvas
                ref="barCanvas"
                style="display: block; width: 100%; height: 100%"
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Orders & Quick Actions -->
    <div class="row mt-2">
      <!-- Recent Orders -->
      <div class="col-lg-8 mb-4">
        <div class="card recent-orders-card h-100">
          <div class="card-header pb-0 pt-4 bg-transparent">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="mb-0 text-dark">
                  <i class="ni ni-bullet-list-67 me-2 text-primary"></i>
                  Pedidos Recentes
                </h6>
                <p class="text-sm text-muted mb-0">
                  Últimos pedidos registrados
                </p>
              </div>
              <router-link to="/pedidos" class="btn btn-sm btn-primary">
                Ver todos
                <i class="ni ni-bold-right ms-1"></i>
              </router-link>
            </div>
          </div>
          <div class="card-body px-0 pb-0">
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead class="bg-light">
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-4"
                    >
                      Pedido
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Cliente
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                    >
                      Status
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                    >
                      Data
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="pedido in pedidosRecentes"
                    :key="pedido._id"
                    class="order-row"
                  >
                    <td class="ps-4">
                      <div class="d-flex align-items-center">
                        <div class="order-icon me-3">
                          <i class="ni ni-bag-17"></i>
                        </div>
                        <div>
                          <h6 class="mb-0 text-sm font-weight-bold">
                            #{{ pedido.pednum }}
                          </h6>
                          <p class="text-xs text-muted mb-0">
                            {{ pedido.produtos ? pedido.produtos.length : 0 }}
                            itens
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-sm font-weight-bold mb-0">
                        {{ pedido.cliente?.nome || "N/A" }}
                      </p>
                      <p class="text-xs text-muted mb-0">
                        {{ formatPhone(pedido.cliente?.fone) }}
                      </p>
                    </td>
                    <td class="text-center">
                      <span :class="getStatusClass(pedido.status)">
                        {{ pedido.status }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="text-sm">{{
                        formatDate(pedido.datapedido)
                      }}</span>
                    </td>
                  </tr>
                  <tr v-if="pedidosRecentes.length === 0">
                    <td colspan="4" class="text-center py-4">
                      <i class="ni ni-cart text-3xl text-muted"></i>
                      <p class="text-muted mt-2 mb-0">
                        Nenhum pedido encontrado
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Quick Actions -->
      <div class="col-lg-4 mb-4">
        <div class="card quick-actions-card h-100">
          <div class="card-header pb-0 pt-4 bg-transparent">
            <h6 class="mb-0 text-dark">
              <i class="ni ni-spaceship me-2 text-warning"></i>
              Ações Rápidas
            </h6>
            <p class="text-sm text-muted mb-0">
              Acesse as principais funcionalidades
            </p>
          </div>
          <div class="card-body">
            <div class="quick-action-grid">
              <router-link to="/clientes" class="quick-action-item">
                <div class="quick-action-icon bg-gradient-primary">
                  <i class="ni ni-single-02"></i>
                </div>
                <div class="quick-action-text">
                  <h6 class="mb-0">Clientes</h6>
                  <p class="text-xs text-muted mb-0">Gerenciar clientes</p>
                </div>
                <i class="ni ni-bold-right text-muted"></i>
              </router-link>

              <router-link to="/pedidos" class="quick-action-item">
                <div class="quick-action-icon bg-gradient-warning">
                  <i class="ni ni-cart"></i>
                </div>
                <div class="quick-action-text">
                  <h6 class="mb-0">Pedidos</h6>
                  <p class="text-xs text-muted mb-0">Ver todos pedidos</p>
                </div>
                <i class="ni ni-bold-right text-muted"></i>
              </router-link>

              <router-link to="/produtos" class="quick-action-item">
                <div class="quick-action-icon bg-gradient-danger">
                  <i class="ni ni-box-2"></i>
                </div>
                <div class="quick-action-text">
                  <h6 class="mb-0">Produtos</h6>
                  <p class="text-xs text-muted mb-0">Catálogo de produtos</p>
                </div>
                <i class="ni ni-bold-right text-muted"></i>
              </router-link>

              <router-link to="/relprodutospordata" class="quick-action-item">
                <div class="quick-action-icon bg-gradient-info">
                  <i class="ni ni-chart-bar-32"></i>
                </div>
                <div class="quick-action-text">
                  <h6 class="mb-0">Relatórios</h6>
                  <p class="text-xs text-muted mb-0">Análises e dados</p>
                </div>
                <i class="ni ni-bold-right text-muted"></i>
              </router-link>
            </div>

            <!-- Status Summary -->
            <div class="status-summary mt-4 p-3 border-radius-lg">
              <h6 class="text-sm font-weight-bold mb-3">
                <i class="ni ni-trophy me-2"></i>
                Resumo do Status
              </h6>
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <span class="text-sm">Taxa de Conclusão</span>
                <span class="font-weight-bold text-success"
                  >{{ completionRate }}%</span
                >
              </div>
              <div class="progress mb-3" style="height: 8px">
                <div
                  class="progress-bar bg-gradient-success"
                  :style="{ width: completionRate + '%' }"
                ></div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-sm">Taxa de Cancelamento</span>
                <span class="font-weight-bold text-danger"
                  >{{ cancellationRate }}%</span
                >
              </div>
              <div class="progress" style="height: 8px">
                <div
                  class="progress-bar bg-gradient-danger"
                  :style="{ width: cancellationRate + '%' }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "dashboard-default",
  data() {
    return {
      doughnutChart: null,
      barChart: null,
      chartsInitialized: false,
    };
  },
  computed: {
    ...mapState({
      dashboardStats: (state) => state.pedidos.dashboardStats,
      pedidosRecentes: (state) => state.pedidos.pedidosRecentes,
    }),
    currentDate() {
      return moment().format("DD/MM/YYYY");
    },
    percentAtivos() {
      if (this.dashboardStats.total === 0) return 0;
      return Math.round(
        (this.dashboardStats.ativos / this.dashboardStats.total) * 100
      );
    },
    percentRetirados() {
      if (this.dashboardStats.total === 0) return 0;
      return Math.round(
        (this.dashboardStats.retirados / this.dashboardStats.total) * 100
      );
    },
    percentCancelados() {
      if (this.dashboardStats.total === 0) return 0;
      return Math.round(
        (this.dashboardStats.cancelados / this.dashboardStats.total) * 100
      );
    },
    completionRate() {
      if (this.dashboardStats.total === 0) return 0;
      return Math.round(
        (this.dashboardStats.retirados / this.dashboardStats.total) * 100
      );
    },
    cancellationRate() {
      if (this.dashboardStats.total === 0) return 0;
      return Math.round(
        (this.dashboardStats.cancelados / this.dashboardStats.total) * 100
      );
    },
  },
  watch: {
    dashboardStats: {
      handler(newVal) {
        console.log("dashboardStats changed:", newVal);
        // Only initialize/update when we have actual data
        if (newVal && newVal.total > 0) {
          console.log(
            "Data available, chartsInitialized:",
            this.chartsInitialized
          );
          if (!this.chartsInitialized) {
            // First time - initialize charts with delay for DOM
            this.$nextTick(() => {
              setTimeout(() => {
                console.log("Initializing charts now...");
                this.initDoughnutChart();
                this.initBarChart();
                this.chartsInitialized = true;
              }, 300);
            });
          } else {
            // Update existing charts
            console.log("Recreating charts...");
            this.recreateCharts();
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    formatPhone(fone) {
      if (!fone) return "N/A";
      return (
        "(" +
        String(fone).slice(0, 2) +
        ")" +
        String(fone).slice(2, 7) +
        "-" +
        String(fone).slice(7)
      );
    },
    getStatusClass(status) {
      const classes = {
        ATIVO: "badge badge-sm bg-gradient-success",
        RETIRADO: "badge badge-sm bg-gradient-warning",
        CANCELADO: "badge badge-sm bg-gradient-danger",
      };
      return classes[status] || "badge badge-sm bg-secondary";
    },
    refreshData() {
      this.$store.dispatch("pedidos/fetchDashboardStats");
      this.$store.dispatch("pedidos/fetchPedidosRecentes", 5);
    },
    initDoughnutChart() {
      const canvas = this.$refs.doughnutCanvas;
      if (!canvas) {
        console.warn("Doughnut canvas not found");
        return;
      }

      // Destroy existing chart if any
      if (this.doughnutChart) {
        this.doughnutChart.destroy();
        this.doughnutChart = null;
      }

      console.log("Creating doughnut chart with data:", this.dashboardStats);
      const ctx = canvas.getContext("2d");
      this.doughnutChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Ativos", "Retirados", "Cancelados"],
          datasets: [
            {
              data: [
                this.dashboardStats.ativos,
                this.dashboardStats.retirados,
                this.dashboardStats.cancelados,
              ],
              backgroundColor: ["#2dce89", "#fb6340", "#f5365c"],
              borderWidth: 0,
              hoverOffset: 10,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: "70%",
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: "#344767",
              titleFont: { size: 14, weight: "bold" },
              bodyFont: { size: 12 },
              padding: 12,
              cornerRadius: 8,
            },
          },
        },
      });
    },
    initBarChart() {
      const canvas = this.$refs.barCanvas;
      if (!canvas) {
        console.warn("Bar canvas not found");
        return;
      }

      // Destroy existing chart if any
      if (this.barChart) {
        this.barChart.destroy();
        this.barChart = null;
      }

      console.log("Creating bar chart with data:", this.dashboardStats);
      const ctx = canvas.getContext("2d");
      const gradient1 = ctx.createLinearGradient(0, 0, 0, 300);
      gradient1.addColorStop(0, "rgba(45, 206, 137, 0.8)");
      gradient1.addColorStop(1, "rgba(45, 206, 137, 0.2)");

      const gradient2 = ctx.createLinearGradient(0, 0, 0, 300);
      gradient2.addColorStop(0, "rgba(251, 99, 64, 0.8)");
      gradient2.addColorStop(1, "rgba(251, 99, 64, 0.2)");

      const gradient3 = ctx.createLinearGradient(0, 0, 0, 300);
      gradient3.addColorStop(0, "rgba(245, 54, 92, 0.8)");
      gradient3.addColorStop(1, "rgba(245, 54, 92, 0.2)");

      this.barChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: ["Ativos", "Retirados", "Cancelados"],
          datasets: [
            {
              label: "Quantidade",
              data: [
                this.dashboardStats.ativos,
                this.dashboardStats.retirados,
                this.dashboardStats.cancelados,
              ],
              backgroundColor: [gradient1, gradient2, gradient3],
              borderRadius: 8,
              borderSkipped: false,
              barThickness: 60,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: "#344767",
              titleFont: { size: 14, weight: "bold" },
              bodyFont: { size: 12 },
              padding: 12,
              cornerRadius: 8,
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
                color: "rgba(0, 0, 0, 0.05)",
              },
              ticks: {
                display: true,
                padding: 10,
                color: "#9ca2b7",
                font: { size: 12 },
              },
            },
            x: {
              grid: {
                display: false,
              },
              ticks: {
                display: true,
                color: "#344767",
                font: { size: 12, weight: "600" },
              },
            },
          },
        },
      });
    },
    recreateCharts() {
      // Destroy existing charts
      if (this.doughnutChart) {
        this.doughnutChart.destroy();
        this.doughnutChart = null;
      }
      if (this.barChart) {
        this.barChart.destroy();
        this.barChart = null;
      }
      // Recreate charts with new data
      this.$nextTick(() => {
        this.initDoughnutChart();
        this.initBarChart();
      });
    },
  },
  mounted() {
    console.log("Dashboard mounted");
    // Fetch data - charts will be initialized when data arrives (via watcher)
    this.$store.dispatch("pedidos/fetchDashboardStats");
    this.$store.dispatch("pedidos/fetchPedidosRecentes", 5);

    // Fallback: try to initialize charts after a delay if data is already present
    setTimeout(() => {
      if (
        this.dashboardStats &&
        this.dashboardStats.total > 0 &&
        !this.chartsInitialized
      ) {
        console.log("Fallback initialization triggered");
        this.initDoughnutChart();
        this.initBarChart();
        this.chartsInitialized = true;
      }
    }, 1000);
  },
  beforeUnmount() {
    this.chartsInitialized = false;
    if (this.doughnutChart) {
      this.doughnutChart.destroy();
      this.doughnutChart = null;
    }
    if (this.barChart) {
      this.barChart.destroy();
      this.barChart = null;
    }
  },
};
</script>

<style scoped>
/* Dashboard Container */
.dashboard-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  min-height: 100vh;
}

/* Dashboard Header */
.dashboard-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.4);
}

/* Statistics Cards */
.stat-card {
  border: none;
  border-radius: 16px;
  color: white;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.stat-card-ativos {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.stat-card-retirados {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.stat-card-cancelados {
  background: linear-gradient(135deg, #eb3349 0%, #f45c43 100%);
}

.stat-card-total {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.stat-number {
  font-size: 2.5rem;
  letter-spacing: -1px;
}

.icon-container {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-container i {
  font-size: 1.5rem;
}

/* Chart Cards */
.chart-card,
.recent-orders-card,
.quick-actions-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.chart-card:hover,
.recent-orders-card:hover,
.quick-actions-card:hover {
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
}

.chart-container {
  height: 220px;
  position: relative;
  width: 100%;
}

.chart-container :deep(canvas) {
  width: 100% !important;
  height: 100% !important;
}

.chart-container-bar {
  height: 280px;
  position: relative;
  width: 100%;
}

.chart-container-bar :deep(canvas) {
  width: 100% !important;
  height: 100% !important;
}

/* Legend Dots */
.legend-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-bottom: 4px;
}

/* Recent Orders Table */
.order-row {
  transition: all 0.2s ease;
}

.order-row:hover {
  background-color: rgba(102, 126, 234, 0.05);
}

.order-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

/* Quick Actions */
.quick-action-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quick-action-item {
  display: flex;
  align-items: center;
  padding: 14px;
  border-radius: 12px;
  background: #f8f9fa;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
}

.quick-action-item:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: translateX(5px);
}

.quick-action-item:hover .quick-action-text h6,
.quick-action-item:hover .quick-action-text p,
.quick-action-item:hover i.ni-bold-right {
  color: white !important;
}

.quick-action-icon {
  width: 45px;
  height: 45px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 12px;
  flex-shrink: 0;
}

.quick-action-text {
  flex: 1;
}

/* Status Summary */
.status-summary {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card,
.chart-card,
.recent-orders-card,
.quick-actions-card {
  animation: fadeInUp 0.6s ease forwards;
}

.col-xl-3:nth-child(1) .stat-card {
  animation-delay: 0.1s;
}
.col-xl-3:nth-child(2) .stat-card {
  animation-delay: 0.2s;
}
.col-xl-3:nth-child(3) .stat-card {
  animation-delay: 0.3s;
}
.col-xl-3:nth-child(4) .stat-card {
  animation-delay: 0.4s;
}

/* Responsive */
@media (max-width: 768px) {
  .stat-number {
    font-size: 1.8rem;
  }

  .dashboard-header h2 {
    font-size: 1.3rem;
  }

  .chart-container,
  .chart-container-bar {
    height: 200px;
  }
}
</style>
